import { defineMessages } from 'react-intl-next';

export default defineMessages({
	acceptLabel: {
		id: 'fabric.editor.ai.screens.acceptReject.acceptLabel',
		defaultMessage: 'Accept',
		description: 'The action text for the accept button to accept the AI generated content',
	},
	rejectLabel: {
		id: 'fabric.editor.ai.screens.acceptReject.rejectLabel',
		defaultMessage: 'Discard',
		description: 'The action text for the discard button to discard the AI generated content',
	},
});
